"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CurrentProjectsCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _components = require("../../../components");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _core = require("@material-ui/core");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    description: {}
  };
});

var CurrentProjectsCard = function CurrentProjectsCard(_ref) {
  var projects = _ref.projects,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["projects", "className"]);

  var classes = useStyles();

  var _useTranslation = (0, _reactI18next.useTranslation)('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(_components.StandardDisplayCard, {
    title: t('dashboard.currentProjectsTitle'),
    className: (0, _clsx.default)(classes.root, className)
  }, projects !== null && projects !== void 0 && projects.length ? /*#__PURE__*/_react.default.createElement(_core.List, null, projects.map(function (project) {
    return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
      button: true,
      key: project.id
    }, /*#__PURE__*/_react.default.createElement(_core.ListItemAvatar, null, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      src: project.companyPhotoUrl
    })), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
      classes: {
        secondary: classes.description
      },
      primary: project.companyName // TODO: this may be html and not a real string - check this!
      ,
      secondary: (0, _lodash.truncate)(project.description, {
        length: 450
      })
    }));
  })) : /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, "No active projects"));
};

exports.CurrentProjectsCard = CurrentProjectsCard;
CurrentProjectsCard.propTypes = {
  projects: _propTypes.default.arrayOf({
    id: _propTypes.default.string.isRequired,
    companyName: _propTypes.default.string.isRequired,
    description: _propTypes.default.string,
    companyPhotoUrl: _propTypes.default.string
  })
};
var _default = CurrentProjectsCard;
exports.default = _default;